export default "__VITE_ASSET__5d904aa7__"